export default {"src":"/_next/static/image/src/images/Footer/spotify.1b6b68ee6513547898596be6de7b4b97.svg","height":20,"width":20};